import {list as roomsList, add, createDirect, get} from "../../api/methods/rooms";
import uniq from "lodash.uniq";
import ChatTypes from "../../enums/ChatTypes";
import NewRoom from '../../models/Rooms/NewRoom';

export default {
    async fetchRooms({commit, rootGetters, dispatch }) {
        try {
            const rooms = await roomsList({
                    take: -1,
                    isMember: true,
                }),
                loadedUsers = rootGetters['chat/profiles/userIds'],
                userIds = uniq(rooms
                    .filter((item) => {
                        return item.type == ChatTypes.direct && item.userId && loadedUsers.indexOf(item.userId) < 0;
                    })
                    .map(item => item.userId));

            if (userIds.length) {
                await dispatch('chat/profiles/fetchProfiles', userIds, {root: true});
            }

            commit('setList', rooms);
        }
        catch (e) {
            dispatch('reportException', e, {root: true});
        }
    },
    /**
     *
     * @param commit
     * @param state
     * @param rootState
     * @param message {Message}
     * @returns {Promise<void>}
     */
    async setLastMessage({commit, state, rootState, dispatch}, message) {
        const index = state.list.findIndex(item => item.id == message.roomID && !item.isHidden);

        if (message.isOut() && rootState.session.userId == message.userID) {
            commit('removeRoom', index);
        }
        else {
            if (index >= 0) {
                const room = state.list[index];
                room.lastMessage = message;

                if (message.userID != rootState.session.userId) {
                    room.unreadCount = (room.unreadCount || 0) + 1;
                }
                commit('setRoom', {index, room});
            } else {
                if (message.isOut() && index < 0) return;
                try {
                    const room = await get(message.roomID);
                    commit('addRoom', room);
                } catch (e) {
                    dispatch('reportException', e, {root: true});
                }
            }
        }
    },
    setIsSeen({state, commit}, {roomId, messageIds}) {
        const roomIndex = state.list.findIndex(item => item.id == roomId);
        if (roomIndex >= 0) {
            state.list[roomIndex].unreadCount = (state.list[roomIndex].unreadCount || 0) - messageIds.length
            if (state.list[roomIndex].unreadCount < 0) {
                state.list[roomIndex].unreadCount = 0;
            }
        }
        commit('setList', [...state.list]);
    },
    async addUsersToChat({commit, dispatch}, {roomId, users}) {
        await add(roomId, users);
        dispatch('chat/groups/removeFromAvailable', roomId, {root: true});
        dispatch('chat/room/setIsMember', true, {root: true});
        dispatch('chat/rooms/fetchRooms', null, {root: true})
    },
    async createDirectRoom({commit, state, rootState, dispatch}, user) {
        try {
            const newRoom = NewRoom.directRoom(user),
                room = await createDirect(newRoom),
                rooms = state.list;
            rooms.push(room);
            commit('setList', [...rooms]);
            return room;
        }
        catch (e) {
            dispatch('reportException', e, {root: true});
            return null;
        }
    },
    async createRoomByUserId({ dispatch, rootState }, userId) {
        let room = null;
        try {
            await dispatch('chat/profiles/fetchProfile', userId, { root: true });
            let user = rootState.chat.profiles.list[userId] || null;
            if (user) {
                room = await dispatch('chat/rooms/createDirectRoom', user, { root: true });
            }
            else {
                dispatch('reportError', 'Пользователь не найден', { root: true });
            }
        }
        catch (e) {
            dispatch('reportException', e, { root: true });
        }

        return room?.id
    }
}
